<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 194.461"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M59.137 121.95c11.552,-17.957 17.745,-39.705 18.579,-65.245 2.986,34.996 -1.791,57.536 -14.332,67.621 -1.062,-0.667 -2.267,-1.23 -4.247,-2.376z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M37.384 122.729c-6.788,-21.699 -7.529,-46.26 -2.224,-73.685 -11.231,36.667 -12.037,61.76 -2.418,75.282 1.179,-0.477 2.468,-0.812 4.642,-1.597z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M58.645 82.962c0.759,-21.037 4.956,-39.391 4.543,-41.274 -1.341,-1.562 -6.383,11.524 -11.468,45.587 1.233,-0.164 3.174,4.374 6.925,-4.313z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M45.528 175.264c-5.329,0.247 -10.031,0.986 -14.107,2.217 -5.168,1.561 -9.328,3.913 -12.481,7.057 2.468,2.021 5.408,3.396 8.684,3.385 2.36,-0.008 4.342,0.127 6.114,0.336 3.465,-3.293 6.88,-5.612 10.244,-6.957 5.398,-3.164 11.223,-0.85 17.477,6.941 2.498,-0.699 4.999,-1.412 7.634,-1.82 3.983,-0.616 8.306,-0.484 11.826,-1.135 -7.873,-5.411 -15.979,-8.675 -24.316,-9.792 -3.647,-0.488 -7.339,-0.565 -11.075,-0.232z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M57.436 150.247c1.634,8.743 1.356,17.16 -0.833,25.249 8.337,1.117 16.443,4.381 24.316,9.792 1.687,-0.312 3.189,-0.803 4.38,-1.643 6.364,-4.487 5.924,-12.818 5.802,-19.333 -0.108,-5.778 -0.693,-16.914 -5.581,-21.511 -0.165,-0.154 -0.334,-0.301 -0.507,-0.44 -1.636,-1.308 -3.536,-2.309 -5.642,-3.071 -3.872,4.526 -7.67,8.159 -15.201,9.784 -2.142,0.463 -4.401,0.855 -6.734,1.173z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M56.603 175.496c2.189,-8.089 2.467,-16.506 0.833,-25.249 -53.978,7.345 -21.954,-17.046 -26.015,27.234 4.076,-1.231 8.778,-1.97 14.107,-2.217 3.736,-0.333 7.428,-0.256 11.075,0.232z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M22.706 148.631c9.757,2.905 23.145,3.192 34.73,1.616 2.333,-0.318 4.592,-0.71 6.734,-1.173 7.531,-1.625 11.329,-5.258 15.201,-9.784 -7.883,-2.853 -18.661,-2.355 -29.373,-2.058 -9.551,0.264 -21.394,1.62 -35.489,1.846 -1.051,0.997 -1.864,2.275 -2.487,3.756 2.422,2.544 6.163,4.452 10.684,5.797z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M31.613 175.039c0.923,-14.267 -2.045,-23.094 -8.907,-26.408 -4.521,-1.345 -8.262,-3.253 -10.684,-5.797 -3.416,8.122 -1.106,22.332 -0.906,29.55 0.848,3.52 3.659,8.733 7.798,12.133 1.394,-1.374 2.989,-2.6 4.782,-3.675 2.26,-1.367 4.835,-2.488 7.725,-3.361 0.076,-0.831 0.141,-1.645 0.192,-2.442z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M61.459 188.243c-6.254,-7.791 -12.079,-10.105 -17.477,-6.941 -3.364,1.345 -6.779,3.664 -10.244,6.957m16.26 -51.027c13.574,-0.376 27.254,-1.075 35.015,5.129 5.355,4.283 5.977,15.979 6.088,21.951 0.122,6.515 0.562,14.846 -5.802,19.333 -3.678,2.592 -10.315,1.866 -16.206,2.778 -6.047,0.936 -11.385,3.481 -17.621,3.766 -10.369,0.474 -13.394,-2.302 -23.848,-2.266 -8.787,0.03 -15.153,-9.915 -16.508,-15.539 -0.237,-8.534 -3.421,-26.841 3.393,-33.306 14.095,-0.226 25.938,-1.582 35.489,-1.846zm36.991 -83.805c3.223,10.208 2.767,39.602 -1.484,89.552m-41.645 -91.246c1.915,-6.556 4.88,-12.855 8.894,-18.897 11.88,-15.356 18.165,-9.546 18.858,17.428m15.377 3.163c-4.902,-13.857 -9.401,-17.232 -13.497,-10.123 -10.444,39.663 -18.285,53.545 -23.523,41.647m0 0c-5.643,-15.995 -6.214,-29.696 -6.46,-45.215 -0.165,-10.48 -8.876,-10.643 -17.353,1.157 -6.432,7.165 -10.353,21.433 -11.762,42.802 0.486,16.194 0.527,34.51 0.104,55.913"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
